/**
 * ColResizeHandle — thin drag handle placed at the right edge of a <th>.
 * Parent <th> must have `position: relative` and an explicit width set.
 */
import React from 'react';

interface ColResizeHandleProps {
  colId: string;
  onStartResize: (colId: string, e: React.MouseEvent) => void;
}

export function ColResizeHandle({ colId, onStartResize }: ColResizeHandleProps) {
  return (
    <div
      aria-hidden
      className="col-resize-handle"
      onMouseDown={(e) => onStartResize(colId, e)}
    />
  );
}
